// Analytics
export const ANALYTICS_ADD_EVENT = 'ANALYTICS_ADD_EVENT';
export const ANALYTICS_CLEAR_EVENTS = 'ANALYTICS_CLEAR_EVENTS';

// Client Identification
export const SET_CLIENT_IS_APP = 'SET_CLIENT_IS_APP';

// Configuration
export const SET_CLIENT_VERSION = 'SET_CLIENT_VERSION';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';

// Feature Management
export const SET_FM_CONFIG_JSON = 'SET_FM_CONFIG_JSON';

// Globalisation
export const SET_LOCALE = 'SET_LOCALE';
export const SET_TENANT = 'SET_TENANT';

// Logging
export const SET_LOG_BASE_PAYLOAD = 'SET_LOG_BASE_PAYLOAD';

// Auth
export const SET_TOKEN = 'SET_TOKEN';
export const SET_RENEW_STARTED = 'SET_RENEW_STARTED';
export const SET_AUTH_FINISHED = 'SET_AUTH_FINISHED';

// Layout
export const SET_HEADER_NAVIGATION_DISABLED = 'SET_HEADER_NAVIGATION_DISABLED';

// Content Cache
export const SET_FOOTER_CONTENT = 'SET_FOOTER_CONTENT';

// Je User Cookie
export const SET_JE_USER_COOKIE = 'SET_JE_USER_COOKIE';
